import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, InputNumber, message } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import AlertWarningCreationSchema from "../../../../Schemas/AlertWarningCreationSchema";
import {
  createAlertWarning,
  updateAlertWarning,
} from "../../../../Services/AlertWarningService";
import { useHistory } from "react-router-dom";

const AlertWarningCreationForm = ({
  data = {},
  counterData,
  callReFetch,
  isEditMode = false,
  onClose,
}) => {
  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      counterCode: data.counterCode || "",
      barcode: data.barcode || "",
      sku: data.sku || "",
      threshold: data.threshold || 0,
    },
    enableReinitialize: true,
    validationSchema: AlertWarningCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const { values } = formik;

  // const isEcomm = values.counterCode === "ECOMMRI";
  const isEcomm = true;

  const handleSubmit = async () => {
    const values = formik.values;

    if (
      isEmpty(values.counterCode) ||
      (!isEcomm && isEmpty(values.barcode)) ||
      (isEcomm && isEmpty(values.sku)) ||
      values.threshold === undefined
    ) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createAlertWarning(values);
        message.success("Alert Warning created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
      } else {
        const updated = await updateAlertWarning(data._id, values);
        callReFetch();
        message.success(
          updated?.data?.message || "Alert Warning updated successfully"
        );
        onClose();
      }
    } catch (err) {
      console.error("Error:", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const titleText = isEditMode
    ? "Alert Warning Detail"
    : "Create Alert Warning";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div style={{ maxWidth: 600, margin: "0 auto" }}>
      <h2 style={{ textAlign: "center" }}>{titleText}</h2>
      <p style={{ textAlign: "center" }}>
        {isEcomm
          ? "SKU & Threshold must be valid"
          : "Barcode & Threshold must be valid"}
      </p>

      <Form
        layout="vertical"
        style={{
          backgroundColor: "#F5F5F5",
          borderRadius: "8px",
          padding: "16px",
        }}
      >
        <Form.Item label="Counter Code" required>
          <Input value="ECOMMRI" disabled />
        </Form.Item>
{/* 
        <Form.Item label="Counter Code" required>
          <Select
            placeholder="Select a counter"
            value={values.counterCode}
            onChange={(value) => formik.setFieldValue("counterCode", value)}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              String(option?.children)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {counterData.map((counter) => (
              <Select.Option key={counter.code} value={counter.code}>
                {counter.name} ({counter.code})
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}

        {!isEcomm && (
          <Form.Item label="Barcode" required>
            <Input
              placeholder="Enter barcode"
              value={values.barcode}
              onChange={(e) => formik.setFieldValue("barcode", e.target.value)}
            />
          </Form.Item>
        )}

        {isEcomm && (
          <Form.Item label="SKU" required>
            <Input
              placeholder="Enter SKU"
              value={values.sku}
              onChange={(e) => formik.setFieldValue("sku", e.target.value)}
            />
          </Form.Item>
        )}

        <Form.Item label="Threshold" required>
          <InputNumber
            min={0}
            placeholder="Enter threshold"
            value={values.threshold}
            onChange={(value) => formik.setFieldValue("threshold", value)}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            style={{ marginRight: "10px" }}
          >
            {submitButtonText}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

AlertWarningCreationForm.propTypes = {
  data: PropTypes.object,
  counterData: PropTypes.array,
  callReFetch: PropTypes.func,
  isEditMode: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AlertWarningCreationForm;
